"use client";

import { useEffect, useState } from "react";
import dynamic from "next/dynamic";
import { Command, Search } from "lucide-react";

const GlobalSearchModal = dynamic(
  () => import("./global-search-modal").then((mod) => mod.GlobalSearchModal),
  { ssr: false },
);

export function GlobalSearch({ compact = false }: { compact?: boolean }) {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === "k") {
        event.preventDefault();
        setOpen(true);
      }
      if (event.key === "Escape") setOpen(false);
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, []);

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className={
          compact
            ? "flex h-10 w-10 shrink-0 items-center justify-center rounded-[10px] transition hover:bg-black/5"
            : "flex min-h-10 items-center gap-2 rounded-[10px] border border-line bg-white px-3 text-sm text-muted transition hover:border-black/25 hover:text-ink"
        }
        aria-label="Search TargetQA"
      >
        <Search size={17} />
        {!compact && (
          <>
            <span className="hidden xl:inline">Search</span>
            <span className="hidden items-center gap-0.5 rounded-md bg-wash px-1.5 py-0.5 text-[10px] font-bold lg:flex">
              <Command size={10} />K
            </span>
          </>
        )}
      </button>
      {open && <GlobalSearchModal onClose={() => setOpen(false)} />}
    </>
  );
}
